import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { DeliveriesPage } from "@/modules/repairs/pages/Deliveries.page";

export const Route = createFileRoute("/__authed/m/repairs/deliveries")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_delivers")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: DeliveriesPage,
});
